import { OwcTypography, OwcTooltip, OwcIconButton } from "@one/react";
import { react18WorkaroundProps } from "../../../../utils/constants/constants";
import moment from "moment";
import PropTypes from "prop-types";
import { getRepetitionIcon } from "../../../../utils/helpers/getRepetitionIcon";
import getRRuleDisplayText from "../../../../utils/helpers/text/transformRRuleToText";
import { useSelector } from "react-redux";

const DateTimeRange = ({ start, end, timezone, repetitionPattern, handleOpenChangeEndTimeModal }) => {
  const user = useSelector(store => store.user);
  const timeFrom = moment(start).tz(timezone).format("hh:mm A");
  const timeTo = moment(end).tz(timezone).format("hh:mm A");
  const dateFromFormatter = moment(start).tz(timezone).format("DD-MMM-YYYY");
  const dateToFormatter = moment(end).tz(timezone).format("DD-MMM-YYYY");
  const recurranceText = getRRuleDisplayText(repetitionPattern, new Date(start), timezone);
  const now = moment.tz(user?.timezone || timezone);
  const isOngoing = now.isSameOrAfter(moment(start)) && now.isBefore(moment(end));
  const displayText = `${dateFromFormatter}, ${timeFrom} - ${dateToFormatter}, ${timeTo}`;
  return (
    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'start', paddingRight: '8px' }}>
      <div>
        <OwcTypography variant="caption">Date and time range</OwcTypography>

        <OwcTypography variant="button" id={"date_time_range_display"}>
          {displayText}
        </OwcTypography>
        <OwcTooltip anchor={"date_time_range_display"} offset={[0, 0]}>
          {displayText}
        </OwcTooltip>
        {recurranceText && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px' }}>
            {getRepetitionIcon(recurranceText)} {recurranceText}
          </div>
        )}
      </div>
      {isOngoing && typeof handleOpenChangeEndTimeModal === "function" && (
        <OwcIconButton
          icon="edit"
          type="outlined"
          flat
          onClick={e => {
            e.stopPropagation?.();
            handleOpenChangeEndTimeModal();
          }}
          style={{ color: "#0B41CD" }}
          {...react18WorkaroundProps}
        />
      )}
    </div>
  );
};

DateTimeRange.propTypes = {
  start: PropTypes.string.isRequired,
  end: PropTypes.string.isRequired,
  timezone: PropTypes.string.isRequired,
  handleOpenChangeEndTimeModal: PropTypes.func,
};

export default DateTimeRange;
